// How long a password has to be, in characters.
//
// W39.79. The number existed in three places that could not see each other: the
// backend's `ChangePasswordRequest.new_password` (`min_length=8`), the DOM's
// `minlength="8"`, and a hint reading 「至少 8 個字元」. Measured on a real
// 393×852 render, the form also carries `noValidate`, so the browser never
// enforces the attribute — a three-character password is sent, the server answers
// 422 with the field and the reason, and the page throws both away and shows one
// line reading 「更改密碼失敗」.
//
// This is the same shape as `lib/retentionWindows.ts`, and for the same reason:
// the number the client states must be the number the server enforces, and the
// cheapest way to keep them from drifting is one definition on this side plus a
// test that reads the contract. `passwordPolicy.test.ts` fails if the backend
// moves the bound and this does not.
//
// Backend source:
//   app.modules.auth.schemas.ChangePasswordRequest.new_password  (minLength: 8)
export const PASSWORD_MIN_LENGTH = 8;

/** The hint under a new-password field: 「至少 8 個字元」. */
export const passwordHint = (): string => `至少 ${PASSWORD_MIN_LENGTH} 個字元`;

/** The refusal under a new-password field, once the server or the client says no. */
export const passwordTooShortMessage = (): string => `新密碼至少需要 ${PASSWORD_MIN_LENGTH} 個字元`;
